@if (toolActive$ | async) {
  @if (isGemeenteGebruiker$ | async) {
    <mat-button-toggle-group (change)="toggleChanged($event)"
                             [value]="activeToggle$ | async"
                             [hideSingleSelectionIndicator]="true">
      <mat-button-toggle value="create">Plan intekenen</mat-button-toggle>
      <mat-button-toggle value="edit">Plan bewerken</mat-button-toggle>
    </mat-button-toggle-group>
  }
  @if (isGemeenteOrProvincieGebruiker$ | async) {
    <button mat-flat-button class="button" (click)="exportPlannen()">Exporteer plannen</button>
  }
}
